import i18n from "../../../i18n"

export const professors =
{
    department: i18n.t("ies_department"),
    professors:
        [
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1743/5917-Nikas_photo-2.jpg',
                fname: i18n.t('christos'),
                lname: i18n.t('nikas'),
                title: i18n.t('proedrosTmimatos'),
                tel: '2310 891.499',
                email: 'xnikas@uom.edu.gr',
                building: 'ΚΖ',
                office: '421Α'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1748/1205-kz-2.jpg',
                fname: i18n.t('konstantinos'),
                lname: i18n.t('zafeiropoulos'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.487',
                email: 'kz@uom.edu.gr',
                building: 'ΚΖ',
                office: '321'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1724/5702-photo_KARVOUNARAKIS-2.jpg',
                fname: i18n.t('theodosios'),
                lname: i18n.t('karvounarakis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.497',
                email: 'theokar@uom.edu.gr',
                building: 'ΚΖ4',
                office: '426'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1734/5586-litsas-2.jpg',
                fname: i18n.t('spyridon'),
                lname: i18n.t('litsas'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.496',
                email: 'litsas@uom.edu.gr',
                building: 'ΚΖ',
                office: '423'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1732/6072-Bitzenis0120_ed-2.jpg',
                fname: i18n.t('aristeidis'),
                lname: i18n.t('mpitzenis'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.498',
                email: 'bitzenis@uom.edu.gr',
                building: 'ΚΖ',
                office: '326'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1738/3055-Skiadas-2.jpg',
                fname: i18n.t('dimitrios'),
                lname: i18n.t('skiadas'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.354',
                email: 'dskiadas@uom.edu.gr',
                building: 'ΚΖ',
                office: '427'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1725/5858-photo_spiropoulos-2.jpg',
                fname: i18n.t('georgios'),
                lname: i18n.t('spiropoulos'),
                title: i18n.t('kathigitis'),
                tel: '2310 891.480',
                email: 'spyr@uom.edu.gr',
                building: 'ΚΖ3',
                office: '330'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1729/5857-Anagnostopoulou_photo-2.jpg',
                fname: i18n.t('despina'),
                lname: i18n.t('anagnostopoulou'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.442', email: 'danag@uom.edu.gr',
                building: 'ΚΖ',
                office: '321Β'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1733/5713-photo_Voskopoulos-2.jpg',
                fname: i18n.t('georgios'),
                lname: i18n.t('voskopoulos'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.445',
                email: 'gvoskop@uom.edu.gr',
                building: 'ΚΖ',
                office: '430'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1741/5916-kiohos_photo-2.jpg',
                fname: i18n.t('apostolos'),
                lname: i18n.t('kiohos'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.556',
                email: 'akiohos@uom.edu.gr',
                building: 'ΚΖ',
                office: '331'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1742/5730-NK-UOM3-2.png',
                fname: i18n.t('nikolaos'),
                lname: i18n.t('koutsoupias'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.747',
                email: 'nk@uom.edu.gr',
                building: 'ΚΖ',
                office: '421B'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1731/1190-icons-2.jpg',
                fname: i18n.t('ioannis'),
                lname: i18n.t('konstantinidis'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.495',
                email: 'icons@uom.edu.gr',
                building: 'ΚΖ',
                office: '323'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1744/1214-smakris-2.jpg',
                fname: i18n.t('spyridon'),
                lname: i18n.t('makris'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.156',
                email: 'smakris@uom.edu.gr',
                building: 'ΚΖ',
                office: '428'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/5393/5731-revecca_pedi_1-2.jpg',
                fname: i18n.t('revekka'),
                lname: i18n.t('pedi'),
                title: i18n.t('Αναπληρώτρια Καθηγήτρια'),
                tel: '2310 891.413',
                email: 'rpedi@uom.edu.gr',
                building: 'ΚΖ',
                office: '328'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1735/5708-photo_Papadopoulos-2.jpg',
                fname: i18n.t('ioannis'),
                lname: i18n.t('papadopoulos'),
                title: i18n.t('anaplirotisKathigitis'),
                tel: '2310 891.486',
                email: 'ipapadopoulos@uom.edu.gr',
                building: 'ΚΖ',
                office: '332B'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1740/1230-vasnik-2.jpg',
                fname: i18n.t('nikolaos'),
                lname: i18n.t('vasileiadis'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.494',
                email: 'vasnik@uom.edu.gr',
                building: 'ΚΖ',
                office: '425'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1746/5703-Photo_Dergiades-2.jpg',
                fname: i18n.t('theologos'),
                lname: i18n.t('dergiades'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.738',
                email: 'dergiades@uom.edu.gr',
                building: 'ΓΔ',
                office: '401'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1739/1201-kmikelis-2.jpg',
                fname: i18n.t('kiriakos'),
                lname: i18n.t('mikelis'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.492',
                email: 'kmikelis@uom.edu.gr',
                building: 'ΚΖ',
                office: '430'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1730/5692-Bellou_photo-2.png',
                fname: i18n.t('fotini'),
                lname: i18n.t('mpellou'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.479',
                email: 'fbellou@uom.edu.gr',
                building: 'ΚΖ',
                office: '332A'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1736/2233-Bozinis_ed-2.jpg',
                fname: i18n.t('thanasis'),
                lname: i18n.t('mpozinis'),
                title: i18n.t('epikourosKathigitis'),
                tel: '2310 891.658',
                email: 'bozinis@uom.edu.gr',
                building: 'ΗΘ4',
                office: '430'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1745/5699-Boutsiouki_photo-2.jpg',
                fname: i18n.t('sofia'),
                lname: i18n.t('mpoutsiouki'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.402',
                email: 'sofiab@uom.edu.gr',
                building: 'ΚΖ',
                office: '325'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/10139/12134-Skevas_photo-2.jpg',
                fname: i18n.t('ioannis'),
                lname: i18n.t('skeuas'),
                title: i18n.t('epikourosKathigitis'),
                tel: '',
                email: 'gskevas@uom.edu.gr',
                building: '',
                office: ''
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1737/1175-chainoglou-2.jpg',
                fname: i18n.t('kalliopi'),
                lname: i18n.t('hainoglou'),
                title: i18n.t('epikouriKathigitria'),
                tel: '2310 891.614',
                email: 'chainoglou@uom.edu.gr',
                building: 'ΚΖ',
                office: '422'
            }
        ]
}